import { type KomboTool as KomboToolResponse } from "../api";
import { Utility } from "./utility";

export interface KomboTool extends KomboToolResponse {}

export class KomboTool extends Utility<KomboTool> {
  constructor(init?: Partial<KomboToolResponse>) {
    super();
    Object.assign(this, init);
  }
}
